const MILES_TO_KILOMETERS = 1.609344;

const preferredUnit = () => window.FestFriends?.distanceUnit ?? 'miles';

const formatDistance = (miles, precision = 0) => {
    if (preferredUnit() === 'kilometers') {
        return `${(miles * MILES_TO_KILOMETERS).toFixed(precision)} km`;
    }

    return `${miles.toFixed(precision)} mi`;
};

const localizeCompanionDistances = () => {
    if (!document.querySelector('.ff-companion-experience')) {
        return;
    }

    document.querySelectorAll('option').forEach((option) => {
        const match = option.textContent.trim().match(/^Within (\d+) miles$/);

        if (!match) {
            return;
        }

        const miles = Number(match[1]);
        option.textContent = `Within ${formatDistance(miles)}`;
    });

    document.querySelectorAll('.ff-companion-experience span').forEach((badge) => {
        const match = badge.textContent.trim().match(/^About ([\d,.]+) miles away$/);

        if (!match) {
            return;
        }

        const miles = Number(match[1].replaceAll(',', ''));

        if (!Number.isFinite(miles)) {
            return;
        }

        badge.textContent = `About ${formatDistance(miles)} away`;
    });
};

document.addEventListener('DOMContentLoaded', localizeCompanionDistances);
